var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container--fluid fill-height"},[_c('PageTitulo',{attrs:{"title":_vm.$t('route.fluxograma')}}),_c('widget-flowchart',{attrs:{"title":"oioioi"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }